import Plyr from "plyr";
import { ancestorBySelector } from "../helpers/element/findAncestor";

export function initPlayers() {

    const playerElements = document.querySelectorAll(".js-player");

    if (playerElements.length > 0) {
        playerElements.forEach(elem => {
            const playerControls = {
                controls: [
                    "play-large",
                    "play",
                    "progress",
                    "current-time",
                    "mute",
                    "volume",
                    "fullscreen"
                ],
                poster: elem.dataset.poster,
            };
            new Plyr(elem, playerControls)
        });
    }

    const playerFullElements = document.querySelectorAll(".js-player-full");

    if (playerFullElements.length > 0) {
        playerFullElements.forEach(elem => {
            const playerControls = {
                controls: [
                ],
                autoplay: true,
                muted: true,
                loop: {
                    active: true
                },
                poster: elem.dataset.poster,
            };
            const fullplayer = new Plyr(elem, playerControls)

            fullplayer.on('ready', event => {
                const parent = ancestorBySelector(event.target, '.hero-video');
                if (parent) {
                    parent.classList.add('is-visible');
                }
            });
        });
    }

    // const playerElementsFullsize = Array.from(document.querySelectorAll(".js-player-full"));
    // const playerControlsFullsize = {
    //     autoplay: true,
    //     muted: true,
    //     loop: { active: true },
    //     controls: []
    // };

    // playersFullsize = playerElementsFullsize.map(p => new Plyr(p, playerControlsFullsize));

    // playersFullsize.forEach(function (player) {
    //     player.on('ready', event => {
    //         event.target.parentElement.classList.add('is-visible');
    //     });
    // });

}
